import React from 'react';
import { isEmpty, isNil } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS } from 'constants/common';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { promptOverlay as promptOverlay } from 'ui/views/widgets/promptOverlay';
 *
 * // render
 * <promptOverlay propName='propValue'/>
 */
export const promptOverlay = ( props ) => {

    return (
        <div className='ui-prompt-overlay'>
        {/* head */}
        <div className='ui-prompt-overlay__head'>
            {/* title */}
            <div className='ui-prompt-overlay__head__title'>
                { ! isEmpty( props.title ) ? props.title: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_CONFIRMATION ) }
            </div>

            {/* close button */}
            <div className='ui-prompt-overlay__head__close' onClick={ () => props.onNoClick() }>
                <Icon name='close' width='14' height='14' fill='#ffffff' />
            </div>
        </div>

        {/* body */}
        <div className='ui-prompt-overlay__body'>

            {/* check if icon is not null, display icon in this case */}
            {
                ! isNil( props.iconName ) && (
                    <div className='ui-prompt-overlay__body__icon'>
                        <Icon name='danger' width='40' height='40' />
                    </div>
                )
            }
            <div className='ui-prompt-overlay__body__description'>
                {
                    ! isEmpty( props.message ) ? props.message : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_ARE_YOU_SURE )
                }
            </div>
        </div>

        <div className='ui-prompt-overlay__actions'>
            <Button
                className='ui-prompt-overlay__actions__item ui-prompt-overlay__actions__item--no'
                title={ { refId: '', value: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_OK ) } }
                outline={ false }
                size='medium'
                onClick={ () => props.onOkClick() }
            />
        </div>
    </div>
    );
};

// set display name
promptOverlay.displayName = 'promptOverlay';

// set default props
promptOverlay.defaultProps = {};

// prop types
promptOverlay.propTypes = {};
